import { render } from "./Borrowers.vue?vue&type=template&id=ad76e734&scoped=true"
import script from "./Borrowers.vue?vue&type=script&lang=js"
export * from "./Borrowers.vue?vue&type=script&lang=js"

import "./Borrowers.vue?vue&type=style&index=0&id=ad76e734&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad76e734"]])

export default __exports__